import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { EnvService } from './env.service';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn = false;
  token: any;
  userInfo: any;

  constructor(
    private http: HttpClient,
    private env: EnvService,
  ) { }

  login(username: String, password: String) {
    return this.http.post(this.env.API_URL + 'users/authenticate',
    {username: username, password: password}
    ).pipe(
      tap(userInfo => {
        localStorage.setItem('user', JSON.stringify(userInfo));

        this.userInfo = userInfo;
        this.isLoggedIn = true;
        return userInfo;
      }),
    );
  }

  logout() {
        localStorage.removeItem("user");
        this.isLoggedIn = false;
        delete this.token;
        return true;
  }

  getUser() {
    if (this.userInfo === undefined) {
      this.userInfo = JSON.parse(localStorage.getItem('user'));
    } 
    return this.userInfo;
  }

  user() {
    const headers = new HttpHeaders({
      'Authoriztion': "Bearer " + this.userInfo["token"]
    });

    return this.http.get<User>(this.env.API_URL + 'user', {headers: headers})
    .pipe(
      tap(user => {
        return user;
      })
    )
  }

  getToken() {
    let user = localStorage.getItem('user')
    return user["token"];
  }
}
